import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";

const empty = { name: "", phone: "", license_no: "" };

export default function Drivers() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/drivers").then(({data})=>setItems(data));
  useEffect(()=>{ load(); }, []);

  const save = async () => {
    try {
      if (editId) await api.put(`/drivers/${editId}`, form);
      else await api.post("/drivers", form);
      toast.success("Saved"); setOpen(false); load();
    } catch(e){ toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const remove = async (id) => { if(!confirm("Delete driver?")) return; await api.delete(`/drivers/${id}`); load(); };

  return (
    <div className="p-8" data-testid="drivers-page">
      <div className="flex items-start justify-between mb-6">
        <div><h1 className="font-display text-3xl text-slate-900">Drivers</h1><p className="text-slate-500 text-sm">Driver master</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="btn-primary" onClick={()=>{setForm(empty); setEditId(null);}} data-testid="new-driver-btn"><Plus size={16}/> New Driver</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editId?"Edit Driver":"New Driver"}</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Name</Label><Input value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} data-testid="driver-name-input"/></div>
              <div><Label>Phone</Label><Input value={form.phone} onChange={(e)=>setForm({...form, phone: e.target.value})}/></div>
              <div><Label>License No</Label><Input value={form.license_no} onChange={(e)=>setForm({...form, license_no: e.target.value})}/></div>
            </div>
            <DialogFooter><Button onClick={save} className="btn-primary" data-testid="save-driver-btn">Save</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="bg-white border border-slate-100 rounded-xl">
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600"><tr>
            <th className="text-left px-4 py-2">Name</th>
            <th className="text-left px-4 py-2">Phone</th>
            <th className="text-left px-4 py-2">License</th>
            <th className="text-right px-4 py-2">Actions</th>
          </tr></thead>
          <tbody>
            {items.length===0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-slate-400">No drivers yet.</td></tr>}
            {items.map(d=>(
              <tr key={d.id} className="border-t border-slate-100">
                <td className="px-4 py-2 font-medium">{d.name}</td>
                <td className="px-4 py-2">{d.phone}</td>
                <td className="px-4 py-2">{d.license_no}</td>
                <td className="px-4 py-2 text-right">
                  <button onClick={()=>{ setForm({name:d.name, phone:d.phone, license_no:d.license_no}); setEditId(d.id); setOpen(true); }} className="p-2 hover:bg-slate-100 rounded"><Pencil size={16}/></button>
                  <button onClick={()=>remove(d.id)} className="p-2 hover:bg-red-50 rounded text-red-600"><Trash2 size={16}/></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>
      </div>
    </div>
  );
}
